module.exports = __webpack_public_path__ + "static/img/吴智华.22754bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/吴智华.jpg
// module id = nNb9
// module chunks = 139